export default __webpack_public_path__ + "static/media/BITWA_1.c66b95ee.gif";